import { ApiResponse, CaseData, HttpResponse } from 'app/types-shared';
import { RemoteData } from 'app/infrastructure/remote-data/index';
import { endpoint } from 'app/area/case/endpoints';
import { primaryKey } from 'app/infrastructure/data/wireformat';
import { ConnectedCaseActionTypes } from 'app/components/connect-existing-cases/connect-existing-cases';

export const api = {

  callsToActions: async (id: number): Promise<any> => {
    const response = await new RemoteData(endpoint.callsToActions(id))
      .resource<ApiResponse<any>>()
      .filter({ caseId: id })
      .single();

    return response.data;
  },

  case: async (id: number): Promise<HttpResponse<CaseData>> => {
    return new RemoteData(endpoint.case).resource<HttpResponse<CaseData>>()
      .withId(id)
      .response();
  },
  changeCaseStatus: async (data: CaseData, eTag: string, includeFailedConstraints: boolean = false, allowWarnings: boolean = true) => {
    return new RemoteData(endpoint.case)
      .resource<HttpResponse<CaseData>>()
      .withId(primaryKey(data))
      .withIfMatch(eTag)
      .filter({ includeFailedConstraints, allowWarnings })
      .save(data);
  },

  onChangeCaseConnection: async ({ caseId, connectedCaseId, connectionTypeId,
    currentConnectedCases, etag, type, allowWarnings = true, utcOffset }: {
      caseId: number;
      connectedCaseId: number;
      connectionTypeId: number;
      currentConnectedCases: number[];
      etag: string;
      type: ConnectedCaseActionTypes;
      allowWarnings: boolean;
      utcOffset?: number;
    }) => {

    const remote = new RemoteData(endpoint.disConnectCase(caseId))
      .resource<any>()
      .filter({ connectedCaseId, connectionTypeId, allowWarnings, utcOffset })
      .withIfMatch(etag);
     const response = type === ConnectedCaseActionTypes.DISCONNECT
            ? await remote.httpDelete(currentConnectedCases)
            : await remote.create(currentConnectedCases);
    const result = await response.json();
    return result?.data;
  }
};
